import React from 'react';

import Problem from './problem'
import Docs from './docs'
import News from './news'
import Info from './info'
import Internalrequests from './internalrequests'
import Contentdraw from './contentdraw'
import './index.css'

const Content = props => {

  const {unit, message, extrasmall, winheight} = props
  const drawparam = {'extrasmall': extrasmall, 'winwidth':winheight}

  return (

      <div className="content">

            {unit == 1 ? <Docs /> : null  }
            {unit == 2 ? <Contentdraw drawparam={drawparam} extrasmall={extrasmall} items={[8,6]} activeItem='6' /> : null  }
            {unit == 3 ? <News extrasmall={extrasmall} drawparam={drawparam} /> : null  }
            {unit == 4 ? <Contentdraw extrasmall={extrasmall} drawparam={drawparam} items={[9,15]} activeItem='15' /> : null  }
            {unit == 5 ? <Contentdraw connectRequest={true} drawparam={drawparam} extrasmall={extrasmall} items={[47,75,71,74]} activeItem='47' /> : null  }
            {unit == 6 ? <Contentdraw extrasmall={extrasmall} drawparam={drawparam} items={[85]} activeItem='85' /> : null  }
            {unit == 7 ? <Contentdraw extrasmall={extrasmall} drawparam={drawparam} items={[76, 32, 78, 79]} activeItem='32' /> : null  }
            {unit == 8 ? <Contentdraw extrasmall={extrasmall} drawparam={drawparam} items={[33, 68]} activeItem='33' /> : null  }
            {unit == 9 ? <Contentdraw  extrasmall={extrasmall} drawparam={drawparam} items={[40]} activeItem='40' /> : null  }
            {unit == 10 ? <Contentdraw extrasmall={extrasmall} drawparam={drawparam} items={[16]} activeItem='16' /> : null  }
            {unit == 11 ? <Contentdraw ticketRequest={true} extrasmall={extrasmall} drawparam={drawparam} items={[17]} activeItem='17' /> : null  }
            {unit == 12 ? <Internalrequests section='ipaddressplan'  /> : null  }

      </div>
  )
}

export default Content
